// extracted by mini-css-extract-plugin
module.exports = {"batch":"batch-bd0c8f52","tips":"tips-4895f2a4"};